/**
 * Compact inline sparkline used by reports.
 *
 * Chart geometry is the one place a money string is allowed to become a number:
 * a pixel coordinate does not need to be exact to the cent.
 */

export function MiniSparkline({
  values,
  width,
  height,
  color,
}: {
  values: readonly number[];
  width: number;
  height: number;
  color: string;
}) {
  if (values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const padding = 1;

  const points = values.map((v, i) => {
    const x = (i / (values.length - 1)) * (width - padding * 2) + padding;
    const y = height - padding - ((v - min) / range) * (height - padding * 2);
    return `${String(x)},${String(y)}`;
  });

  const last = points[points.length - 1]!.split(',');

  return (
    <svg width={width} height={height} className="flex-shrink-0">
      <polyline
        points={points.join(' ')}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={last[0]} cy={last[1]} r="2" fill={color} />
    </svg>
  );
}
